import '.bp{min-height:100vh;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import { styled } from 'inlines'
import { ComponentType, ReactNode } from 'react'
import { colors } from '../../tokens/colors.js'
import { NewCMSRouteEvents } from './index.js'

export type NewCMSAuthorizeProps = {
  component?: ComponentType<any>
  children?: ReactNode
  on?: NewCMSRouteEvents
}

export function NewCMSAuthorize(_: NewCMSAuthorizeProps) {
  return null
}

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="bp h a b c"
      style={{
        background: colors.neutralInverted100,}}
    >
      {children}
    </div>
  )
}
